import { render, staticRenderFns } from "./animais.vue?vue&type=template&id=f970e66c&scoped=true"
import script from "./animais.vue?vue&type=script&lang=js"
export * from "./animais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f970e66c",
  null
  
)

export default component.exports